import {Component} from '@angular/core';

@Component({
    selector: 'app-bdm-news',
    templateUrl: './bdm-news.component.html',
    styleUrls: ['./bdm-news.component.css']
    })
export class BdmNewsComponent {

    hasNews = false;

    onNewsLoaded(count: number): void {
        this.hasNews = count > 0;
    }
}
